export default __webpack_public_path__ + "static/media/pokedex.21141e9a.jpg";